import React from 'react';
import { connect } from 'react-redux';
// Levelpopup imports
import { close } from '../../../actions/levelPopupActions';
// Shared imports
import settings from '../../../../settings';

class LevelPopupLayout extends React.Component {
    onClose = () => {
        const { dispatch, levelPopup } = this.props;
        dispatch(close());

        if (levelPopup.onClose) {
            levelPopup.onClose();
        }
    };

    render = () => {
        const { id, imgSrc, imgAlt, isSmallImg, title, clickable, children } = this.props;

        let clickHand = <></>;
        let clickFunction = () => {};
        if (clickable) {
            clickHand = <img src={`${settings.assetsPath}img/icons/pointer_klikhand.png`} alt="Klik om verder te gaan" className="click-hand-icon" />;
            clickFunction = this.onClose;
        }

        return (
            <div id="gameplayer-level-popup-container" onClick={clickFunction}>
                <div className="level-popup" id={id}>
                    <div className="level-popup-content-container">
                        <div className="title-container">
                            <div className="title-image">
                                <img src={`${settings.assetsPath}img/${imgSrc}`} alt={imgAlt} className={isSmallImg ? 'is-small' : ''} />
                            </div>
                            <span>{title}</span>
                        </div>
                        <div className="level-popup-content">{children}</div>
                    </div>
                    {clickHand}
                </div>
            </div>
        );
    };
}

LevelPopupLayout.defaultProps = {
    id: '',
    imgSrc: '',
    imgAlt: '',
    isSmallImg: false,
    title: '',
    content: <></>,
    clickable: false
};

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    levelPopup: state.levelPopup
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LevelPopupLayout);
